import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { BrandDetail } from './Detail';
import { BrandsList } from './List';

export const BrandsRoutes = ({ match }) => {
  return (
    <Switch>
      <Route exact path={match.url} component={BrandsList} />
      <Route path={`${match.url}/:topicId`} component={BrandDetail} />
    </Switch>
  );
};
